import api from '../api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { CrfFiltros } from './crfRelatorioCicloorcamentario';

const controller = 'crfReportProjetoPacote'

export interface RelatorioProjetoPacote {
    id: string;
    numeroLinha: number;

    totvs: string;
    tab: string;

    codProjeto: string;
    nmProjeto: string;


    diretoria: string;
    area: string;
    departamento: string;
    grupo: string;
    subGrupo: string;
    naoPrevisto: string;



    codPacote: string;
    nomePacote: string;

    orcado: string;
    contratado: string;
    executado: string;
    requisitado: string;
    compromissado: string;
    aContratar: string;
    forecast: string;
    variacao: string;



    orcadoJaneiro: string;
    orcadoFevereiro: string;
    orcadoMarco: string;
    orcadoAbril: string;
    orcadoMaio: string;
    orcadoJunho: string;
    orcadoJulho: string;
    orcadoAgosto: string;
    orcadoSetembro: string;
    orcadoOutubro: string;
    orcadoNovembro: string;
    orcadoDezembro: string;



    executadoForecastJaneiro: string;
    executadoForecastFevereiro: string;
    executadoForecastMarco: string;
    executadoForecastAbril: string;
    executadoForecastMaio: string;
    executadoForecastJunho: string;
    executadoForecastJulho: string;
    executadoForecastAgosto: string;
    executadoForecastSetembro: string;
    executadoForecastOutubro: string;
    executadoForecastNovembro: string;
    executadoForecastDezembro: string;
}

export interface ReportProjetoPacoteResult {
    executadoForecastJunhoTotal: string;
    executadoForecastJulhoTotal: string;
    executadoForecastAgostoTotal: string;
    executadoForecastSetembroTotal: string;
    executadoForecastOutubroTotal: string;
    executadoForecastNovembroTotal: string;
    executadoForecastDezembroTotal: string;
    executadoForecastMaioTotal: string;
    executadoForecastAbrilTotal: string;
    executadoForecastMarcoTotal: string;
    executadoForecastFevereiroTotal: string;
    executadoForecastJaneiroTotal: string;

    orcadoJaneiroTotal: string;
    orcadoFevereiroTotal: string;
    orcadoMarcoTotal: string;
    orcadoAbrilTotal: string;
    orcadoMaioTotal: string;
    orcadoJunhoTotal: string;
    orcadoJulhoTotal: string;
    orcadoAgostoTotal: string;
    orcadoSetembroTotal: string;
    orcadoOutubroTotal: string;
    orcadoNovembroTotal: string;
    orcadoDezembroTotal: string;
    requisitadoTotal: string;
    compromissadoTotal: string;
    aContratarTotal: string;
    forecastTotal: string;
    variacaoTotal: string;
    executadoTotal: string;
    contratadoTotal: string;
    orcadoTotal: string;
    ultimoMesExecutado: number;
    listReportProjetoPacote: RelatorioProjetoPacote[]
}

export const getAllProjetoPacote = () => { return api.get<ReportProjetoPacoteResult[]>('reportProjetoPacote/getAll'); }

export const postExportarRelatorio = () => {
    let urlBase = window.location.origin;
    trackPromise(Axios.post(urlBase + `/api/${controller}/exportar`, {},
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "relatorioProjetoPacote.xlsx");
            link.setAttribute('id', 'relatorioProjetoPacoteId');
            document.body.appendChild(link);
            link.click();
            document.getElementById('relatorioProjetoPacoteId').outerHTML = '';
        }));
};

export const exportaRelatorioPluriAnualExcel = (values: CrfFiltros) => {

    let urlBase = window.location.origin;
    trackPromise(Axios.post(urlBase + `/api/crfRelatorioCicloOrcamentario/postGetAllRelatorioPluriAnualExportar`, values,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "relatorioPluriAnualExportar.xlsx");
            link.setAttribute('id', 'relatorioPluriAnualExportarId');
            document.body.appendChild(link);
            link.click();
            document.getElementById('relatorioPluriAnualExportar').outerHTML = '';
        }));
};